module.exports = __webpack_public_path__ + "static/media/topup2.39045a87.png";